import React, { createContext, useContext, useEffect, useState } from "react";
import { getAdminContentLanguage, setAdminContentLanguage } from "../services/LangPrefs";

const AdminLanguageContext = createContext();

export const useAdminLanguage = () => {
    const context = useContext(AdminLanguageContext);
    if (!context) {
        // Return default values instead of throwing error to allow usage outside AdminLanguageProvider
        // This is needed for components like WordMeaning that are used in both admin and user contexts
        return {
            language: "english",
            setLanguage: () => {
                console.warn("setLanguage called outside AdminLanguageProvider - no effect");
            }
        };
    }
    return context;
};

export const AdminLanguageProvider = ({ children }) => {
    // Load language from localStorage on initialization, default to "english"
    const [language, setLanguageState] = useState(() => {
        return getAdminContentLanguage();
    });

    // Save language to localStorage whenever it changes
    useEffect(() => {
        setAdminContentLanguage(language);
    }, [language]);

    // Wrapper function to update language state
    const setLanguage = (newLanguage) => {
        setLanguageState(newLanguage);
    };

    const value = {
        language,
        setLanguage
    };

    return (
        <AdminLanguageContext.Provider value={value}>
            {children}
        </AdminLanguageContext.Provider>
    );
};
